var unitPrice = "{{ pricePerUnit }} l’unité";
var unitsCount = "{{ unitsCount }} unités";
var unitCount = "{{ unitsCount }} unité";
var unitPriceWithQuantity = "{{ pricePerUnit }} l’unité / {{ unitsCount }} unités";
var vatInclusive = "Taxes de vente incluses";
var vatExclusive = "Taxes de vente en sus";
var excludeShipping = "{{ shipping }} en sus";
var includeShipping = "{{ shipping }} incluses";
var shipping = "expédition";
var vatAndShipping = {
	includeVatExcludeShipping: "TPS/TVH incluses {{ shipping }} en sus",
	excludeVatIncludeShipping: "TPS/TVH en sus, {{ shipping }} incluses",
	includeVatIncludeShipping: "TPS/TVH incluses, {{ shipping }} incluses",
	excludeVatExcludeShipping: "TPS/TVH en sus {{ shipping }} en sus"
};
var priceSummary = "Résumé du prix";
var priceSummaryInfoIcon = "Icône des informations de résumé du prix";
var priceSummaryModal = "Modal du résumé du prix";
var priceSummaryCloseModal = "Fermer le modal du résumé du prix";
var priceSummaryTermsAndConditions = "* Pour chaque commande, un écran ou un tampon unique est fabriqué, et l’équipement est ajusté pour l’impression de votre graphisme. ";
var priceSummaryBasePrice = "Prix de base";
var priceSummarySetupFee = "Frais d’installation*";
var priceSummarySubtotal = "Sous-total";
var differentialPrice = {
	included: "Inclus",
	forUnits: "{{ differentialPrice }} pour {{ quantity }} unités",
	forUnit: "{{ differentialPrice }} pour {{ quantity }} unité"
};
var priceFrom = "De {{ price }}";
var priceFromEach = "À partir de {{ price }} l’unité";
var volumeDiscount = "Remise de {{volumeDiscount}} % sur les volumes";
var volumeDiscountPlusSale = "Remise de {{volumeDiscount}} % sur les volumes + Solde";
var rangePrice = "De {{xx}} à {{yy}}";
var unitRangePrice = "{{rangePrice}} chacun";
var originalPrice = "prix initial :";
var salePrice = "prix réduit actuel :";
var setupFee = "Les frais d’installation de {{ setupFee }} s’appliquent";
var noSetupFee = "Pas de frais d’installation";
var vatAndSetupFee = {
	noVatInclSetup: "Incluant des frais d’installation de {{ setupFee }}",
	inclVatAndSetup: "Incluant des frais d’installation de {{ setupFee }} et la TPS/TVH",
	exclVatInclSetup: "Incluant des frais d’installation de {{ setupFee }}, sans la TPS/TVH",
	inclVatSetupInclShipping: "Incluant des frais d’installation de {{ setupFee }} et la TPS/TVH, incluant l’{{ shipping }}",
	inclVatSetupExclShipping: "Incluant des frais d’installation de {{ setupFee }} et la TPS/TVH, sans l’{{ shipping }}",
	exclVatSetupInclShipping: "Incluant des frais d’installation de {{ setupFee }}, sans la TPS/TVH, incluant l’{{ shipping }}",
	exclVatSetupExclShipping: "Incluant des frais d’installation de {{ setupFee }}, sans la TPS/TVH et l’{{ shipping }}"
};
var priceFor = "{{ quantity }} pour {{ price }}";
var frca = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { frca as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
